module.exports = __webpack_public_path__ + "0661cf4.woff2";